export const HTTP_STATUS_ERRORS = {
  401: {
    title: '認証エラー',
    body: `認証の有効期限切れ、もしくは認証エラーのため<br>
      ログアウトします。`,
    hideCloseIcon: true,
  },
  500: {
    title: 'サーバーエラー',
    body: `サーバーエラーのため、アクセスできませんでした。<br>
      しばらくたってからもう一度お試しください。`,
    hideCloseIcon: true,
  },
  NO_INTERNET: {
    title: 'ネットワークエラー',
    body: `ネットワークに接続できませんでした。<br>
    ネットワークが繋がる状態か確認の上、再度実行してください。`,
    hideCloseIcon: false,
  },
  common: {
    title: 'ネットワークエラー',
    body: `ネットワークに接続できませんでした。<br>
      ネットワークが繋がる状況か<br>
      確認のうえ、再度実行してください。`,
    hideCloseIcon: false,
  },
};

// validation error messages
const VALIDATION_ERRORS = {
  FIELD_REQUIRED: '必須項目です',
  VALUE_REQUIRED: 'を入力してください',
  HALF_WIDTH: '半角で入力してください',
  KATAKANA: '全角カタカナで入力してください',
  NUMERIC: '数字で入力してください',
  INTEGER: '数字で入力してください',
  ALPHANUMERIC: '英数字のみ入力してください',
  ADMIN_LOGIN_ID: '有効なログインIDを入力してください',
  ADMIN_LOGIN_PASSWORD: '有効なパスワードを入力してください',
  MINMAXLENGTH: 'xx〜yy文字を入力してください。',
  RANGE_XX_TO_YYY: 'xx以上yy以下で入力してください',
  INVALID_EMAIL: '有効なメールアドレスを入力してください。',
  INVALID_TEL: 'ハイフンを使って電話番号形式で入力してください',
  INVALID_POSTALCODE: '「000-0000」の形式で入力してください',
  LOGIN_FAILED: 'メールアドレスまたはパスワードが正しくありません',
  REGISTER_PASSWORD_FAIL:
    'パスワードの変更に失敗しました。もう一度ご確認ください。',
  TEMPORARY_PASSWORD_FAIL:
    'メールアドレス、もしくは仮パスワードが違います。もう一度ご確認ください。',
  TEMPORARY_PASSWORD_DIALOG_ERROR_TITLE: 'エラー',
  REGISTER_PASSWORD_DIALOG_ERROR_TITLE: 'パスワード設定エラー',
  ERROR_CONFIRM_PASSWORD: 'パスワードと確認用パスワードが一致しません。',
  ERROR_CONFIRM_EMAIL: 'メールアドレスと確認用メールアドレスが一致しません',
  MAIL_ADDRESS_DUPLICATION: 'すでに登録済みのメールアドレスです',
  ALPHA: '英字のみ入力してください',
  FILE_SIZE:
    'ファイルが大きすぎます。アップロード可能なファイルサイズは〇〇までです。',
  FILE_TYPE: 'アップロード可能なファイルはPDF形式のみです。',
  SYMBOL_ERROR: '{field}には記号文字が必須です。',
  PASSWORD_INVALID_CHARS: '半角英数記号で入力してください。',
  PASSWORD_SYMBOL_REQUIRED: 'パスワードには記号が必要です。',
  PASSWORD_LOWERCASE_REQUIRED: 'パスワードには小文字が必要です。',
  PASSWORD_UPPERCASE_REQUIRED: 'パスワードには大文字が必要です。',
  PASSWORD_NUMERIC_REQUIRED: 'パスワードには数字が必要です。',
  SYSTEM_ERROR:
    '問題が発生したため、処理を中断しました。<br>再度、操作をやり直してください。',
  NETWORK_ERROR: 'ネットワークエラーが発生しました。',
  LOGIN_WRONG_CREDENTIALS:
    'メールアドレスまたはパスワードが間違っているようです。',
  EMAIL_MAX_LENGTH: '80文字以内で入力してください。',
  SIGNUP_INCOMPLETE:
    'まだサインアップが完了していません。<br>ユーザー登録を完了してください。',
};

// video stream error messages
export const VideoStreamErrorMessages = {
  LiveNoFragmentFound: {
    text: '映像の再生に失敗しました。接続状態を確認して、もう一度お試しください。',
    theme: 'dark-bg',
  },
};

export const errorMessages = {
  ...VALIDATION_ERRORS,
  API_ERROR: { error: { message: 'ネットワークエラーが発生しました。' } },
  httpStatus: HTTP_STATUS_ERRORS,
};
